// utils/teamTypeUtils.js

// Team type configurations with icons and colors
export const teamTypeConfig = {
  office: {
    icon: '🏢',
    label: 'Office',
    className: 'team-type-office',
    color: '#1976d2'
  },
  candidate: {
    icon: '👥',
    label: 'Candidate',
    className: 'team-type-candidate',
    color: '#7b1fa2'
  },
  military: {
    icon: '🎖️',
    label: 'Military',
    className: 'team-type-military',
    color: '#c62828'
  },
  security: {
    icon: '🛡️',
    label: 'Security',
    className: 'team-type-security',
    color: '#f57c00'
  },
  operations: {
    icon: '⚙️',
    label: 'Operations',
    className: 'team-type-operations',
    color: '#2e7d32'
  },
  research: {
    icon: '🔬',
    label: 'Research',
    className: 'team-type-research',
    color: '#00796b'
  },
  custom: {
    icon: '✨',
    label: 'Custom',
    className: 'team-type-custom',
    color: '#667eea'
  }
};

// Function to get display text for team type
export const getTeamTypeDisplay = (team) => {
  if (!team) return null;
  
  const type = team.team_type || 'office';
  const config = teamTypeConfig[type] || teamTypeConfig.custom;
  
  if (type === 'custom' && team.custom_type) {
    return {
      icon: config.icon,
      text: team.custom_type,
      className: config.className,
      color: config.color,
      fullDisplay: `${config.icon} ${team.custom_type}`
    };
  } else {
    return {
      icon: config.icon,
      text: config.label,
      className: config.className,
      color: config.color,
      fullDisplay: `${config.icon} ${config.label}`
    };
  }
};

// Function to get badge class
export const getTeamTypeBadgeClass = (teamType) => {
  const config = teamTypeConfig[teamType] || teamTypeConfig.custom;
  return config.className;
};